import { render, staticRenderFns } from "./ButtonProduct.vue?vue&type=template&id=3febc6ee&scoped=true&"
import script from "./ButtonProduct.vue?vue&type=script&lang=js&"
export * from "./ButtonProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3febc6ee",
  null
  
)

export default component.exports